import React from 'react';
import styled from 'styled-components';
import { getIn } from 'seamless-immutable';
import BuyBox from '@catalogo/ui-americanas-desktop-buybox';
import OutOfStockDisclaimer from '@catalogo/ui-americanas-mobile-out-of-stock-disclaimer';
import { withDiscountProgressiveExperiment } from '@catalogo/service-americanas-product/src/hocs/discount-progressive-expetiment';
import OffersBox from './offers-box';
import { ExclusivePrime } from './exclusive-prime';
import BuyArea from './buy-area';
import { DeliveryFlow } from './delivery-flow';

export const ProductOffer = props => {
  const { currentSku, product } = props;
  const offer = getIn(currentSku, ['offers', 'result', '0']);
  const hasOffer = !!offer;
  const primeDiscount = getIn(offer, ['bestPaymentOption', 'hasPrimeDiscount']);
  const isDigital = getIn(product, ['isDigital']);
  const hasDelivery = hasOffer && !isDigital;

  return (
    <Container>
      {primeDiscount && <ExclusivePrime />}
      {hasOffer ? <BuyBox {...props} /> : <OutOfStockDisclaimer {...props} />}
      {hasDelivery && <DeliveryFlow {...props} />}
      {hasOffer && (
        <>
          <BuyArea {...props} />
          <OffersBox {...props} />
        </>
      )}
    </Container>
  );
};

const Container = styled.div`
  background: #fff;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  width: 360px;
  padding: 0 16px;
`;

export default withDiscountProgressiveExperiment(ProductOffer);
